<script setup>
import { ref, computed, defineAsyncComponent, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
/***/
import { useApplicationStore } from '@stores/application';
import { useUserStore } from '@stores/user';
/***/
import { useAuthUser } from '@compositions/Auth';

// Composants
const Loader = defineAsyncComponent(() => import(/* webpackChunkName: "components" */ '@components/UI/Loader'));
const Layout = defineAsyncComponent(() => import(/* webpackChunkName: "components" */ '@components/Layouts/Authenticated'));
const RemainingTaskList = defineAsyncComponent(() => import(/* webpackChunkName: "components" */ '@components/Partial/Me/Task/List/Managing/List/Remaining'));
const CompletedTaskList = defineAsyncComponent(() => import(/* webpackChunkName: "components" */ '@components/Partial/Me/Task/List/Managing/List/Completed'));

// Router
const router = useRouter();
const route = useRoute();

// I18n
const { t } = useI18n();

// Store
const applicationStore = useApplicationStore();
const userStore = useUserStore();

const currentApplication = computed(() => applicationStore.getCurrent);

const { authUser, authUserHasPermission, authUserIsTeamManager } = useAuthUser({});
const allowed = ref(false);

// Chargement des agents, pour pouvoir les filtrer
const loadingAgents = ref(false);
const loadAgentsError = ref(false);
const loadAgents = (() => {
    if(loadingAgents.value) {
        return;
    }

    loadingAgents.value = true;
    userStore.loadUserListOfType('AGENT', {
        limit: 10
    }).then(() => {

    }).catch(() => {
        loadAgentsError.value = true;
    }).finally(() => {
        loadingAgents.value = false;
    });
});

onMounted(() => {

    const canConsult = (authUserHasPermission('consult tasks') && authUserIsTeamManager.value);
    if(! canConsult) {
        router.push({
            name: 'error',
            params: {
                statusCode: 404
            }
        });
    } else {
        allowed.value = true;
        document.title = t('page.me.task.managing.list.title') + ' - ' + currentApplication.value.name;

        loadAgents();
    }
});
</script>

<template>
    <layout v-if="allowed">
        <loader v-if="loadingAgents"></loader>
        <p
            v-else-if="loadAgentsError"
            class="generic-message generic-message-error"
        >
            {{ $t('page.me.task.managing.list.errorAgents') }}
        </p>
        <template v-else>
            <div class="content_header">
                <div class="content-header_title">
                    <h1 class="first-title">{{ $t('page.me.task.managing.list.title') }}</h1>
                    <p>{{ $t('page.me.task.managing.list.description') }}</p>
                </div>
            </div>
            <remaining-task-list></remaining-task-list>
            <completed-task-list></completed-task-list>
        </template>
    </layout>
</template>
